import {FormControl, RadioGroup, TextField} from '@mui/material';
import {bool, func, number, string} from 'prop-types';

import {REGULAR_EXPRESSIONS_ERROR_TEXTS} from '../../../../const';
import {capitalizeWord} from '../../../../utils';
import FormUppercaseLabel from '../../../form/FormUppercaseLabel/FormUppercaseLabel';
import Radio from '../../../form/Radio/Radio';
import UploadDropzone from '../../../upload/UploadDropzone';

const ImportReportForm = ({
  reportContainsSecurityOnData,
  setReportContainsSecurityOnData,
  reportSecurityOnDataRole,
  setReportSecurityOnDataRole,
  isSecurityOnReportRoleNameValid,
  fileUploadError,
  setFiles
}) => {
  const getSecurityOnDataRoleHelperText = () => {
    if (!isSecurityOnReportRoleNameValid && reportSecurityOnDataRole !== '') return REGULAR_EXPRESSIONS_ERROR_TEXTS.labelWithRangeChars(1, 50);

    const capitalizedPolicyName = capitalizeWord(import.meta.env.VITE_COMPANY_POLICY);
    return `La mise en place de la sécurité sur les données nécessite une table de sécurité comprenant les emails de vos utilisateurs. Vos utilisateurs doivent utiliser ces emails pour se connecter à ${capitalizedPolicyName}.`;
  };

  const securityOnReportRoleHelperText = getSecurityOnDataRoleHelperText();

  return (
    <>
      <FormUppercaseLabel label="Glisser-déposer un fichier Power BI (.pbix)" />
      <UploadDropzone
        maximumNumberOfFiles={1}
        error={fileUploadError}
        onFilesUpload={setFiles}
        acceptedFileTypes={{
          'application/pbix': ['.pbix']
        }}
      />

      <FormControl sx={{mt: 3}}>
        <FormUppercaseLabel label="Ce fichier contient-il de la sécurité sur les données ?" />
        <RadioGroup
          row
          value={reportContainsSecurityOnData}
          onChange={() => {
            setReportContainsSecurityOnData(reportContainsSecurityOnData === 1 ? 0 : 1);
          }}
          aria-labelledby="report contains security on data"
          name="security-on-data-role"
        >
          <Radio value={1} label="Oui" checked={reportContainsSecurityOnData === 1} />
          <Radio value={0} label="Non" checked={reportContainsSecurityOnData === 0} />
        </RadioGroup>
      </FormControl>

      {Boolean(reportContainsSecurityOnData) && (
        <TextField
          required
          value={reportSecurityOnDataRole}
          onChange={event => {
            setReportSecurityOnDataRole(event.target.value);
          }}
          label="Rôle"
          placeholder="Veuillez saisir le nom donné au rôle (sensible à la casse)"
          color="primary"
          fullWidth
          error={!isSecurityOnReportRoleNameValid && reportSecurityOnDataRole !== ''}
          helperText={securityOnReportRoleHelperText}
          sx={{
            mt: 1.5
          }}
        />
      )}
    </>
  );
};

ImportReportForm.propTypes = {
  reportContainsSecurityOnData: number.isRequired,
  setReportContainsSecurityOnData: func.isRequired,
  reportSecurityOnDataRole: string.isRequired,
  setReportSecurityOnDataRole: func.isRequired,
  isSecurityOnReportRoleNameValid: bool.isRequired,
  fileUploadError: string.isRequired,
  setFiles: func.isRequired
};

export default ImportReportForm;
